define('charts/layers/metricslayer',["require", "exports", "../../tracks/track-enabled", "../../util/convert"], function (require, exports, trackEnabled, convert_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.MetricsLayer = void 0;
    var MetricsLayer = /** @class */ (function () {
        function MetricsLayer() {
        }
        MetricsLayer.prototype.init = function (chart) {
            var _this = this;
            var _a;
            // Add svg group
            this.svgGroup = chart.layers.space.append("g")
                .attr("class", "distance metrics");
            this.first11 = this.svgGroup.append("g")
                .attr("class", "first11");
            this.cross11 = this.svgGroup.append("g")
                .attr("class", "cross11");
            this.feather = this.svgGroup.append("g")
                .attr("class", "feather");
            // Bind to metrics button
            (_a = document.getElementById("studio-metrics-button")) === null || _a === void 0 ? void 0 : _a.addEventListener("click", function () {
                if (_this.svgGroup.style("display") === "inline") {
                    _this.svgGroup.style("display", "none");
                }
                else {
                    _this.svgGroup.style("display", "inline");
                }
            });
        };
        MetricsLayer.prototype.update = function (chart) {
            // TODO: Object.values ES2017
            var tracks = Object.keys(trackEnabled.enabled)
                .map(function (k) { return trackEnabled.enabled[k]; })
                .filter(function (t) { return t.isBASE(); });
            // First 1:1 point
            var first11s = this.first11.selectAll("circle")
                .data(tracks);
            first11s.enter()
                .append("circle")
                .attr("r", 4)
                .style("stroke-width", 0)
                .style("fill", function (t) { return t.stats.first11_x ? "#4b4" : "none"; })
                .attr("cx", function (t) { return chart.xAxis.scale(convert_1.default.distance.localValue(t.stats.first11_x)); })
                .attr("cy", function (t) { return chart.yAxis[0].scale(convert_1.default.distance.localValue(-t.stats.first11_y)); });
            first11s
                .attr("cx", function (t) { return chart.xAxis.scale(convert_1.default.distance.localValue(t.stats.first11_x)); })
                .attr("cy", function (t) { return chart.yAxis[0].scale(convert_1.default.distance.localValue(-t.stats.first11_y)); });
            first11s.exit().remove();
            // Cross 1:1 point
            var cross11s = this.cross11.selectAll("circle")
                .data(tracks);
            cross11s.enter()
                .append("circle")
                .attr("r", 4)
                .style("stroke-width", 0)
                .style("fill", function (t) { return t.stats.cross11 ? "#e71" : "none"; })
                .attr("cx", function (t) { return chart.xAxis.scale(convert_1.default.distance.localValue(t.stats.cross11)); })
                .attr("cy", function (t) { return chart.yAxis[0].scale(convert_1.default.distance.localValue(-t.stats.cross11)); });
            cross11s
                .attr("cx", function (t) { return chart.xAxis.scale(convert_1.default.distance.localValue(t.stats.cross11)); })
                .attr("cy", function (t) { return chart.yAxis[0].scale(convert_1.default.distance.localValue(-t.stats.cross11)); });
            cross11s.exit().remove();
            // Feather point
            var feathers = this.feather.selectAll("circle")
                .data(tracks);
            feathers.enter()
                .append("circle")
                .attr("r", 4)
                .style("stroke-width", 0)
                .style("fill", function (t) { return t.stats.feather ? "#e1a" : "none"; })
                .attr("cx", function (t) { return chart.xAxis.scale(convert_1.default.distance.localValue(t.stats.feather)); })
                .attr("cy", function (t) { return chart.yAxis[0].scale(convert_1.default.distance.localValue(-200)); });
            feathers
                .attr("cx", function (t) { return chart.xAxis.scale(convert_1.default.distance.localValue(t.stats.feather)); })
                .attr("cy", function (t) { return chart.yAxis[0].scale(convert_1.default.distance.localValue(-200)); });
            feathers.exit().remove();
        };
        MetricsLayer.prototype.remove = function () {
            this.svgGroup.remove();
        };
        return MetricsLayer;
    }());
    exports.MetricsLayer = MetricsLayer;
});
//# sourceMappingURL=/assets/javascripts/charts/layers/metricslayer.js.map;
